import React, { useEffect, useState } from "react";
import { BulkLostPackages } from "@secondcloset/web-components";

import { useUploadBulkLostCsv } from "./hooks/useUploadBulkLostCsv";

import * as S from "./styles";

import { useDownloadCsvTemplate } from "./hooks/useDownloadCsvTemplate";
import { validateCsv } from "./helpers/validateCsv";

export const BulkLostPackagePage: React.FC = () => {
  const [lostPackagesCsvFile, setLostPackagesCsvFile] = useState<File>();
  const [csvError, setCsvError] = useState<string[]>([]);

  const { uploadCsv, isUploading, isSuccess: isUploadSuccess } = useUploadBulkLostCsv();
  const { downloadCsvTemplate, isDownloadingTemplate } = useDownloadCsvTemplate();

  useEffect(() => {
    isUploadSuccess && setLostPackagesCsvFile(undefined);
  }, [isUploadSuccess]);

  const onSubmitClick = () => {
    if (!lostPackagesCsvFile) return;
    uploadCsv({ bulkLostCsv: lostPackagesCsvFile });
  };

  const onSetCsv = async (csv?: File) => {
    if (!csv) {
      // remove uploaded csv
      setLostPackagesCsvFile(undefined);
      return;
    }
    try {
      await validateCsv(csv);
      setLostPackagesCsvFile(csv);
      setCsvError([]);
    } catch (errors) {
      setCsvError((errors as string[]).slice(0, 50));
    }
  };

  return (
    <S.Container>
      <BulkLostPackages
        csvFile={lostPackagesCsvFile}
        errors={csvError}
        isDownloadingTemplate={isDownloadingTemplate}
        isUploadingCsv={isUploading}
        setCsvFile={onSetCsv}
        onDownloadTemplate={downloadCsvTemplate}
        onSubmitClick={onSubmitClick}
      />
    </S.Container>
  );
};
